// This file should be deleted once it has been decoupled from all components that use this.

var InFlight = InFlight || {};

InFlight.eventSearch = (function() {
    var _departmentSelectId = "departmentSelect";
    var _iconPath = "/images/departments/";
    var _departmentDict;
    var _departments = [
    {
        id:"ALL",
        name:"All"
    },
    {
        id: "EXT",
        name: "Non-City Departments (Public/Private Opportunities)"
    }];    

    var _getIconPathFromEventTitle = function (title) {
        var depID = "EXT";
        if (title.length >= 3) {
            depID = title.substr(0, 3);
        }
        if (_departmentExists(depID)) {
            return _iconPath+"icon-"+depID+".svg";
        }
        return _iconPath+"icon-EXT.svg";
    };

    var _departmentExists = function(department) {
        if (!_departmentDict) {
            _prepareDepartmentDictionary();
        }

        if (_departmentDict[department]) {
            return true;
        } else {
            return false;
        }
    };

    var _prepareDepartmentDictionary = function() {
        _departmentDict = {};
        $.each(_departments, function (index, item) {
            _departmentDict[item.id] = item.name;
        });        
    }

    var _createDepartmentSelect = function () {
        var count = _departments.length;

        var select = $('<select/>', {
            id: _departmentSelectId,
            class: 'form-control'
        });
        for (var i = 0; i < count; i++) {
            var department = _departments[i];
            $('<option/>', {
                val: department.id,
                text: department.name
            }).appendTo(select);
        }

        return select;
    };

    var _getDepartmentSelect = function () {
        return $('[id='+_departmentSelectId+']');
    };

    var _addDepartmentSelect = function ($container) {        
        var $currentSelect = _getDepartmentSelect();
        if ($container && !$currentSelect.length) {
            var $select = _createDepartmentSelect();
            $container.append($select);
        }        
    };

    var _getProcessedSearchValue = function(search) {
        var $department = _getDepartmentSelect();
        var trimmedSearch = search.trim();
        var dep = $department.val();
        if (dep != '' && dep != 'ALL') {
            var depSearch = '%'+dep+'%';
            if (trimmedSearch.length > 0) {
                depSearch += '%'+trimmedSearch+'%';
            }
            return depSearch;            
        } else {
            var nonDepSearch = trimmedSearch.replace(/%/g, "");
            return nonDepSearch;
        }        
    }

    var _getDepartmentFromSearchValue = function (search) {
        var regExp = /^%(.{3})%/gm;
        var match = regExp.exec(search);
        if (match && match.length === 2) {
            return match[1];
        };
        return undefined;
    };

    var _getCleanSearchValue = function (search) {
        if (search.indexOf('%') >= 0) {
            var regExp = /^%(?:.{3})%(?:%(.*)%)?$/gm;
            var match = regExp.exec(search);        
            if (match && match.length === 2) {
                return match[1];
            } else {
                return "";
            };
        }
        return search;        
    };

    var _setDepartmentSelectFromSearchValue = function (search) {
        var dep = _getDepartmentFromSearchValue(search);
        if (dep) {
            var $select = _getDepartmentSelect();
            $select.val(dep);
        }
    };

    return {
        getIconPathFromEventTitle: _getIconPathFromEventTitle,
        getProcessedSearchValue: _getProcessedSearchValue,
        setDepartmentFromSearchValue: _setDepartmentSelectFromSearchValue,
        addDepartmentSelect: _addDepartmentSelect,
        getCleanSearchValue: _getCleanSearchValue
    };
})();